import { CaseReducer, createSlice, PayloadAction } from '@reduxjs/toolkit';
import { FinalExamTypeModel } from 'data/exam/exam.model';

type SliceState = {
  status: 'idle' | 'loading' | 'data' | 'error';
  data: FinalExamTypeModel[];
  error: any;
};

const initState: SliceState = {
  status: 'idle',
  data: [],
  error: false,
};

const setLoading = (): SliceState => ({ ...initState, status: 'loading' });

const setData: CaseReducer<SliceState, PayloadAction<FinalExamTypeModel[]>> = (_, action) => ({
  error: false,
  data: action.payload,
  status: 'data',
});

const setError: CaseReducer<SliceState, PayloadAction<any>> = (state, action) => ({
  error: action.payload,
  data: [],
  status: 'error',
});

const examFinalTypeSlice = createSlice({
  name: 'examFinalType',
  initialState: initState,
  reducers: {
    setLoading,
    setData,
    setError,
  },
});

export default examFinalTypeSlice;
